// MDRN: Kaching is the sole cart drawer. The native theme cart drawer
// (type === 'cart', identified by its #CartContainer) still gets opened
// by theme.min.js on a successful add-to-cart, independent of the
// ajax_cart_method setting. Rather than hiding it with CSS, we close it
// the same way a user would — by triggering its own close button —
// the instant it mounts. Search and quick-view drawers use the same
// wrapper markup but never render #CartContainer, so they're untouched.
(function () {
  function closeNativeCartDrawer(root) {
    var container = root.querySelector ? root.querySelector('#CartContainer') : null;
    if (!container) return;
    var drawer = root.closest ? root.closest('.drawer--cart') : null;
    if (!drawer) return;
    var closeBtn = drawer.querySelector('.js-drawer-close');
    if (closeBtn) closeBtn.click();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.id === 'CartContainer') {
          closeNativeCartDrawer(node);
        } else if (node.querySelector) {
          var found = node.querySelector('#CartContainer');
          if (found) closeNativeCartDrawer(found);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
